<template>
    <div class="admin-layout">
      <!-- 左侧导航栏 -->
      <aside class="sidebar">
        <!-- logo + 菜单 -->
        <div class="sidebar-logo">
          <img class="sidebar-logo-img" src="@/assets/images/白字.png" alt="logo" />
          <!-- <div class="sidebar-logo-info">
            <div class="sidebar-title">声瀚网络科技</div>
            <div class="sidebar-subtitle">SHENGHAN NETWORK TECHNOLOGY</div>
          </div> -->
        </div>
        <el-menu :default-active="$route.path" class="sidebar-menu" background-color="#222" text-color="#fff" active-text-color="#3BB2FF" router  >
          <el-menu-item index="/"><i class="el-icon-s-home"></i> 首页</el-menu-item>
          <el-menu-item index="/power"><i class="el-icon-s-data"></i> 权限管理</el-menu-item>
          <el-menu-item index="/card"><i class="el-icon-tickets"></i> 卡密管理</el-menu-item>
          <el-menu-item index="/room"><i class="el-icon-document"></i> 群组管理</el-menu-item>
          <el-menu-item index="/proxy"><i class="el-icon-data-analysis"></i> 代理数据</el-menu-item>
        </el-menu>
      </aside>
      <!-- 主体内容 -->
      <div class="main-content">
        <!-- 头部 -->
        <header class="header-bar">
          <div class="header-left" style="    display: flex;justify-content: center;align-items: center;margin-left: 20px;">
            <el-avatar :size="36" src="https://user-avatar-url.com/avatar.jpg"></el-avatar>
            <span class="header-username">管理员</span>
          </div>
          <div class="header-right">
            
            <i class="el-icon-more"></i>
            <i class="el-icon-refresh" style="margin-left:24px;" @click="handleRefresh"></i>
          </div>
        </header>
        <!-- 页面内容区 -->
        <div class="content-area">
          <router-view :key="refreshKey"/>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "LayoutPage",
    data() {
      return {
        refreshKey: 0 // 初始化 key
      }
    },
    methods: {
      handleRefresh() {
        this.refreshKey += 1; // key 改变 => router-view 重新挂载
      }
    }
  }
  </script>
  

  <style scoped>
  .admin-layout {
    display: flex;
    width: 100vw;
    height: 100vh;
    background: #fff;
  }
  
  .sidebar {
    width: 220px;
    background: #222;
    color: #fff;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .sidebar-logo {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 22px 16px 18px 16px;
  }
  
  .sidebar-logo-img {
    width: 200px;
    height: 38px;
    margin-right: 8px;
    object-fit: contain;
  }
  
  .sidebar-logo-info {
    display: flex;
    flex-direction: column;
  }
  
  .sidebar-title {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
  }
  
  .sidebar-subtitle {
    font-size: 10px;
    letter-spacing: 1px;
    margin-top: 2px;
  }
  
  .sidebar-menu {
    border: none;
    background: #222;
    margin-top: 16px;
  }
  
  .main-content {
    flex: 1;
    /* display: flex; */
    flex-direction: column;
    background: #fff;
  }
  
  .header-bar {
    height: 60px;
    background: #888;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 36px 0 0;
  }
  
  .header-right {
    display: flex;
    align-items: center;
  }
  
  .header-username {
    margin-left: 10px;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
  }
  
  .content-area {
    padding: 18px 0 10px 18px;
    width: 98%;
  }
  
  .content-title {
    font-size: 16px;
    color: #222;
    margin-bottom: 28px;
    font-weight: 500;
  }
  
  .card-list {
    display: flex;
    flex-direction: row;
    gap: 32px;
  }
  
  .renew-card {
    background: #f7f7f7;
    border-radius: 20px;
    box-shadow: 0 2px 8px #eee;
    width: 200px;
    height: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 18px 0 0 0;
  }
  
  .renew-card-img {
    width: 110px;
    height: 150px;
    border-radius: 14px;
    object-fit: cover;
    margin-bottom: 16px;
  }
  
  .renew-card-info {
    width: 170px;
    text-align: center;
  }
  
  .renew-card-title {
    font-size: 14px;
    font-weight: 500;
    color: #222;
    margin-bottom: 6px;
  }
  
  .renew-card-desc {
    font-size: 13px;
    color: #7a7a7a;
  }

  html, body, #app {
    height: 100%;
    margin: 0;
    }
  </style>